// extracted by mini-css-extract-plugin
export default {"menuBlock":"JE-z","title":"KE-z","nav":"LE-z","flexCell":"ME-z","facetLink":"NE-z"};